
// Single source of truth for version management
export const BUILD_ID = "20250424-001";
export const APP_VERSION = BUILD_ID;
export const BUILD_DATE = "2025-04-24";
export const BUILD_TIMESTAMP = "2025-04-24T00:00:00.000Z";

// Version info interface
export interface VersionInfo {
  version: string;
  buildId: string;
  buildTime: string;
  environment: string;
  forceRefresh: boolean;
  lastUpdateCheck: string;
  cacheControl: {
    enabled: boolean;
    maxAge: number;
    staleWhileRevalidate: number;
  };
}
